import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-component-icon',
  templateUrl: './design-component.component.html'
})
export class DesignComponentComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
